// src/features/landing/domain/surveys.js
// 설문 화면 로직. 설문 정의(표지 cover·질문 questions)는 recruit-api GET /api/surveys/{code}가 내려준다
// (DB survey.question_json이 정본, 문항 변경·마감은 운영 SQL — claude-hub risingbrokers-api/claude/2610_survey).
// 사용처: SurveyPage (/survey/:code)
//
// 질문 type (서버가 검증하는 형식은 이 두 가지뿐)
//  - choice : 단일 선택 (options[].value · label · sub) — 답변 키는 질문 id, 값은 선택지 value(문자열)
//  - number : 숫자 입력 + 슬라이더 (fields[] 하나 이상) — 답변 키는 필드 key, 값은 숫자
// 화면 전용 필드(summary·category·desc·note·hint·short·ticks·annualSum)는 서버가 검증에 쓰지 않고 그대로 내려준다.
// 마지막 회사 정보(회사명·이름·연락처·개인정보 동의) 단계는 질문 정의에 없고 SurveyPage가 붙인다.
// 숫자 필드는 기본값 없이 비어 있는 상태로 시작한다 — 손대지 않고 넘긴 값이 응답으로 저장되지 않게 하기 위함.

export const SURVEY_CLOSED_MESSAGE = "마감된 설문입니다"; // POST 400 message (서버 계약 문구)

// 응답 요약 표시용 — 값이 없으면 null
export function formatAnswer(question, answers) {
    if (question.type === "choice") {
        const opt = question.options.find((o) => o.value === answers[question.id]);
        return opt ? opt.label : null;
    }
    const parts = question.fields.map((f) => {
        const v = answers[f.key];
        if (v == null) return null;
        return { f, text: `${v.toLocaleString("ko-KR", { minimumFractionDigits: f.dec, maximumFractionDigits: f.dec })}${f.unit === "%" ? "%" : f.unit === "명" ? "명" : ""}` };
    });
    if (parts.some((p) => p == null)) return null;
    if (parts.length === 1) return parts[0].text;
    // 월 매출: "손보 0.7 · 생보 0.3억"
    return parts.map((p) => `${p.f.short} ${p.text}`).join(" · ") + "억";
}

export function isAnswered(question, answers) {
    if (question.type === "choice") return answers[question.id] != null;
    return question.fields.every((f) => answers[f.key] != null);
}

// 다음 단계로 넘어갈 수 있는지 — required가 없으면 false(서버와 같음)라 건너뛸 수 있다
export function canProceed(question, answers) {
    return !question.required || isAnswered(question, answers);
}

// 제출용 answers — 현재 정의에 있는 키만 정의 순서대로 담는다(정의에 없는 키는 서버가 400).
// number 값은 숫자 타입이어야 한다(문자열 "120"이면 서버 400).
export function buildAnswerPayload(questions, answers) {
    const payload = {};
    questions.forEach((q) => {
        if (q.type === "choice") {
            if (answers[q.id] != null) payload[q.id] = answers[q.id];
            return;
        }
        (q.fields || []).forEach((f) => {
            const v = answers[f.key];
            if (v != null && v !== "" && !isNaN(+v)) payload[f.key] = +v;
        });
    });
    return payload;
}

export function validateSurveyContact(contact) {
    const errors = {};
    if (!contact.company.trim()) errors.company = "회사명을 입력해 주세요.";
    if (!contact.name.trim()) errors.name = "이름을 입력해 주세요.";
    else if (contact.name.trim().length > 50) errors.name = "이름은 50자 이하로 입력해 주세요.";
    const digits = contact.phone.replace(/\D/g, "");
    if (!digits) errors.phone = "연락처를 입력해 주세요.";
    else if (digits.length < 9 || digits.length > 11) errors.phone = "연락처를 정확히 입력해 주세요.";
    if (!contact.privacyAgreed) errors.privacyAgreed = "개인정보 수집·이용에 동의해 주세요.";
    return errors;
}
